import { RegionAuditCreatableInterface } from '../interfaces/region-audit-creatable.interface';
import { RegionAuditDto } from './region-audit.dto';
import { IntersectionType, PartialType, PickType } from '@nestjs/swagger';

export class RegionAuditCreateDto
  extends IntersectionType(
    PickType(RegionAuditDto, [
      'regionId',
      'actionType',
      'changedByUserId',
      'name',
      'archived',
      'repairsRate',
      'specialJobsPercentage',
      'pieceworkPercentage',
      'allowPayoutAmountEditing',
      'interiorOptionsPercentage',
      'exteriorOptionsPercentage',
      'trimOptionPercentage',
      'phaseStructureType',
      'garageCostFixed',
      'dwHangingCostPerBoard',
      'dwFinishingCostPerBoard',
      'dwSprayingCostPerBoard',
      'highCeilingPerBoard',
      'screwInspectionPerBoard',
      'dwpHangingCostPerBoard',
      'dwpFinishCostPerBoard',
      'dwpPrimeCostPerSqft',
      'dwpBump1CostPerBoard',
      'dwpTrim1CostPerSqft',
      'dwpInteriorPaintCostPerSqft',
      'dwpBump2CostPerBoard',
      'dwpTrim2CostPerSqft',
      'dwpFinalPaintCostPerSqft',
      'dwpBump3CostPerBoard',
      'dwpCMBluetapeCostPerSqft',
      'dwpFinalBluetapeCostPerSqft',
    ]),
    PartialType(
      PickType(RegionAuditDto, ['changeReason']),
    ),
  )
  implements RegionAuditCreatableInterface {}

